import React, { useState, useEffect } from "react";
import { TrainingNavbar } from "./reusedcomponent/navbar";
import DatePicker from 'react-datepicker'
import {ApiService} from '../../../../services/ApiService'
import { Formik, Form, Field} from "formik";
import {useAlert} from 'react-alert'

export const EditTheme = (route) => {
    const [users,setUsers]=useState([])
    const [datas,setDatas] = useState(null)
    const alert = useAlert()
    const request = async()=>{
        const getUser = await await ApiService.post('get-all-active-users') 
        const data = await ApiService.get(`edit-theme/${route.match.params.id}`);
        console.log(getUser)
        setDatas(data.data.data)
        setUsers(getUser.data.data)
    }

    useEffect(()=>{
        request()
    },[])
    return (
        <React.Fragment>
            <TrainingNavbar />
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="table-wrapper table-responsive">
                                <div class="row">                           
                            <div class="col-sm-12 col-md-12 col-xs-12" id="munch_learn_content_wrapper">
                                <div class="">
                                    {datas !== null ?
                                <Formik
                        initialValues={{ name: datas.name, due_date: datas.due_date, email:datas.email ,theme:datas.theme, id:datas.id}}
                        validate={values => {
                            // const errors = {};
                            // if (!values.email) {
                            //     errors.email = "Required";
                            // } else if (
                            //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                            //         values.email
                            //     )
                            // ) {
                            //     errors.email = "Invalid email address";
                            // }
                            // return errors;
                        }}
                        onSubmit={(values) => {
                            console.log(values)
                            ApiService.post("update-theme", values).then(res => {
                                console.log(res)
                                if(res.data.type===false){
                                    alert.error(res.data.msg)
                                }else if(res.data.type === true){
                                alert.success(res.data.msg)
                            }
                            })
                        }}
                    >
                        {({ isSubmitting,values,setFieldValue }) => (
                            <Form>
                                <div>

                                            <div className="form-group">
                                               
                                                    <label >Presenter <span className="text-danger"> * </span></label>
                                                    
                                                    <Field as="select" className="form-control" name="name">
                                                        <option selected>--Select User--</option>

                                                        {users.map((user, i) => (
                                                                <option value={user.first_name +' '+ user.last_name} key={i}>
                                                                {user.first_name +' '+ user.last_name}
                                                                </option>
                                                            ))}
                                                    </Field>
                                                
                                                
                                            </div>

                                        
                                
                                            <div className="form-group">
                                                <label>
                                                    Presenter Email{" "}
                                                    <span className="text-danger">
                                                        {" "}
                                                        *{" "}
                                                    </span>
                                                </label>
                                                <Field as="select" className="form-control" name="email">

                                                        {users.map((user, i) => (
                                                                <option value={user.email} key={i}>
                                                                {user.email}
                                                                </option>
                                                            ))}
                                                    </Field>
                                            </div>
                                            <div className="form-group">
                                                <label>
                                                    Due Date{" "}
                                                    <span className="text-danger">
                                                        {" "}
                                                        *{" "}
                                                    </span>
                                                </label>
                                                <div className="form-group">
                                                    <DatePicker 
                                                    selected={Date.parse(values.due_date)}
                                                    dateFormat="MMMM d, yyyy"
                                                    className="form-controls"
                                                    name="due_date"
                                                    onChange={date => setFieldValue('due_date', date)}
                                                    />
                                            </div>
                                            </div>

                                            <div className="form-group">
                                                <label>Topic</label>
                                                <Field
                                                    as='textarea'
                                                    type="text"
                                                    col="4"
                                                    id="tpoic"
                                                    className="form-control item"
                                                    name="theme"
                                                    placeholder="Enter Topic"
                                                />
                                            </div>
                                <div className="form-group">
                                    <button type="submit" className="btn btn-block nt-button-color-default">
                                        Submit 
                                    </button>
                                </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                    :null}
                                        
                                </div>
                            </div>
                        </div>
                    </div>
                            </div>
                 </div>
                 </div>
            </div>
        </React.Fragment>
    );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/trainingmanagement/themeoftheweek/edit_tow.js